import { giftDrawerSelectors } from "src/features/giftsDrawer/exports/state";
import { RootState } from "src/state/delegate";
import { giftsCacheSelectors } from "src/state/selectors";

const NUMBER_OF_GIFTS_PER_ROW = 4;

const calculateRows = (amount: number) =>
  Math.ceil(amount / NUMBER_OF_GIFTS_PER_ROW);

const findCollectionsPosition = (
  giftId: string,
  collectionIds: string[],
  state: RootState
) => {
  let rows = 0;
  let col = 1;
  for (const giftCollectionId of collectionIds) {
    const collection = giftsCacheSelectors.getCollectionById(
      state,
      giftCollectionId
    );
    if (collection) {
      const collectionGiftsAmount = collection.giftIds?.length || 0;
      const giftIndex = collection.giftIds?.indexOf(giftId);

      if (giftIndex !== -1) {
        const positionInCollection = giftIndex + 1;
        col =
          positionInCollection % NUMBER_OF_GIFTS_PER_ROW ||
          NUMBER_OF_GIFTS_PER_ROW;
        rows += calculateRows(positionInCollection);
        break;
      }
      rows += calculateRows(collectionGiftsAmount);
    }
  }

  return { col, rows };
};

export const findGiftPosition = (state: RootState, giftId: string) => {
  const categories = giftDrawerSelectors.getCategories(state);
  const categoryIds = giftDrawerSelectors.getCategoryIdsList(state);
  const { positionIndex, categoryId } =
    giftsCacheSelectors.getOptionLastClickedGift(state);

  if (typeof positionIndex !== "number" || !categoryId) {
    return null;
  }

  const position = positionIndex + 1;
  let totalRows = 0;
  let column = 1;
  for (const giftCategory of categoryIds) {
    const category = categories[giftCategory];
    if (category) {
      const categoryGiftsAmount = category.giftIds?.length || 0;
      if (giftCategory === categoryId) {
        if (category.collectionIds?.length > 0) {
          const { col, rows } = findCollectionsPosition(
            giftId,
            category.collectionIds,
            state
          );
          totalRows += rows;
          column = col;
          break;
        }

        totalRows += calculateRows(position);
        column = position % NUMBER_OF_GIFTS_PER_ROW || NUMBER_OF_GIFTS_PER_ROW;
        break;
      }

      if (category.collectionIds?.length > 0) {
        const { rows } = findCollectionsPosition(
          giftId,
          category.collectionIds,
          state
        );
        totalRows += rows;
      }
      totalRows += calculateRows(categoryGiftsAmount);
    }
  }

  return `${column},${totalRows}`;
};
